import React, {
  useEffect,
  useState
} from "react";

import {
  useNavigate,
  useParams,
  useSearchParams
} from "react-router-dom";


function InlineSelectionNavbar({ darkMode, setDarkMode, activeNav = "Home" }) {
  const navigate = useNavigate();

  const [searchOpen, setSearchOpen] = useState(false);
  const [searchText, setSearchText] = useState("");
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [accountName, setAccountName] = useState("Kids");

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}
  }, [darkMode]);

  const handleNavClick = (item) => {
    setMobileMenuOpen(false);

    if (item === "Home" || item === "Teachers" || item === "Subjects") {
      navigate("/teacher-demo");
      return;
    }

    if (item === "My Learning") {
      navigate("/profile");
    }
  };

  const themeToggle = () => {
    setDarkMode((current) => !current);
  };

  return (
    <>
      <style>{`
        .selection-navbar {
          position: sticky;
          top: 0;
          z-index: 5000;
          height: 72px;
          margin: 0 -40px 27px;
          padding: 0 48px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          background: linear-gradient(180deg, #050505 0%, #080808 100%);
          border-bottom: 1px solid rgba(255,255,255,.08);
          backdrop-filter: blur(12px);
          -webkit-backdrop-filter: blur(12px);
        }

        .selection-navbar-left,
        .selection-navbar-right,
        .selection-menu,
        .selection-search-area {
          display: flex;
          align-items: center;
        }

        .selection-navbar-left { gap: 32px; min-width: 0; }
        .selection-menu { gap: 8px; }
        .selection-navbar-right { gap: 10px; }

        .selection-menu button {
          border: none;
          background: transparent;
          padding: 10px 17px;
          color: rgba(255,255,255,.68);
          font-size: 16px;
          line-height: 20px;
          font-weight: 500;
          cursor: pointer;
          border-radius: 24px;
          white-space: nowrap;
          transition: .2s ease;
        }

        .selection-menu button:hover,
        .selection-menu button.active {
          background: #333338;
          color: #fff;
        }

        .selection-icon-button {
          width: 38px;
          height: 38px;
          border: none;
          border-radius: 50%;
          background: transparent;
          color: #fff;
          display: flex;
          align-items: center;
          justify-content: center;
          cursor: pointer;
          padding: 0;
          transition: .2s ease;
          flex-shrink: 0;
        }

        .selection-icon-button:hover,
        .selection-icon-button.active {
          background: #333338;
        }

        .selection-icon-button svg {
          width: 23px;
          height: 23px;
          display: block;
        }

        .selection-search-area { gap: 7px; }

        .selection-search-input {
          width: 220px;
          height: 36px;
          border: 1px solid rgba(255,255,255,.25);
          border-radius: 5px;
          outline: none;
          background: #181818;
          color: #fff;
          padding: 0 11px;
          font-size: 14px;
        }

        .selection-search-input::placeholder { color: rgba(255,255,255,.5); }

        .selection-kids-item {
          height: 38px;
          display: flex;
          align-items: center;
          gap: 7px;
          padding: 0 6px;
          border: none;
          border-radius: 6px;
          background: transparent;
          color: #fff;
          cursor: pointer;
        }

        .selection-kids-item:hover { background: #333338; }

        .selection-kids-logo {
          width: 32px;
          height: 32px;
          border-radius: 4px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          background: linear-gradient(135deg,#8d42b9 0%,#d34f9d 48%,#f3b33d 48%,#f3b33d 100%);
        }

        .selection-kids-logo span {
          color: #fff;
          font-size: 9px;
          font-weight: 800;
          background: rgba(220,60,170,.75);
          padding: 2px 1px;
        }

        .selection-kids-text { font-size: 16px; font-weight: 500; }
        .selection-kids-arrow { width: 9px; height: 9px; }

        .selection-profile {
          display: flex;
          align-items: center;
          gap: 3px;
        }

        .selection-profile-icon {
          width: 38px;
          height: 38px;
          border-radius: 6px;
          display: flex;
          align-items: center;
          justify-content: center;
          background: #f2c900;
          color: #fff;
          cursor: pointer;
          border: none;
        }

        .selection-profile-icon svg { width: 24px; height: 24px; }
        .selection-profile-arrow { width: 10px; height: 10px; color: #aaa; }

        .selection-mobile-button { display:none; }

        .selection-mobile-panel {
          position: fixed;
          top: 72px;
          left: 12px;
          right: 12px;
          z-index: 4999;
          padding: 8px;
          border-radius: 8px;
          background: #181818;
          border: 1px solid rgba(255,255,255,.12);
          box-shadow: 0 15px 40px rgba(0,0,0,.65);
        }

        .selection-mobile-panel button {
          width:100%;
          height:44px;
          border:0;
          border-radius:6px;
          background:transparent;
          color:#ddd;
          text-align:left;
          padding:0 14px;
          font-size:15px;
          cursor:pointer;
        }

        .selection-mobile-panel button:hover,
        .selection-mobile-panel button.active {
          background:#333338;
          color:#fff;
        }

        .light-mode .selection-navbar {
          background: #fff;
          border-bottom-color: rgba(0,0,0,.10);
          box-shadow: 0 1px 8px rgba(0,0,0,.06);
        }

        .light-mode .selection-menu button { color: rgba(0,0,0,.68); }

        .light-mode .selection-menu button:hover,
        .light-mode .selection-menu button.active {
          background:#e7e7e7;
          color:#111;
        }

        .light-mode .selection-icon-button,
        .light-mode .selection-kids-item { color:#111; }

        .light-mode .selection-icon-button:hover,
        .light-mode .selection-icon-button.active,
        .light-mode .selection-kids-item:hover { background:#eeeeee; }

        .light-mode .selection-search-input {
          background:#f7f7f7;
          color:#111;
          border-color:rgba(0,0,0,.16);
        }

        .light-mode .selection-search-input::placeholder { color:rgba(0,0,0,.45); }

        .light-mode .selection-mobile-panel {
          background:#fff;
          border-color:rgba(0,0,0,.12);
          box-shadow:0 15px 40px rgba(0,0,0,.18);
        }

        .light-mode .selection-mobile-panel button { color:#333; }

        .light-mode .selection-mobile-panel button:hover,
        .light-mode .selection-mobile-panel button.active {
          background:#e8e8e8;
          color:#111;
        }

        @media (max-width: 900px) {
          .selection-navbar {
            padding:0 25px;
            margin-left:-25px;
            margin-right:-25px;
          }

          .selection-menu { gap:2px; }
          .selection-menu button { padding:10px; font-size:14px; }
        }

        @media (max-width: 768px) {
          .selection-navbar {
            height:72px;
            margin:0 -20px 25px;
            padding:0 20px;
          }

          .selection-menu { display:none; }
          .selection-mobile-button { display:flex; }
          .selection-navbar-right { gap:5px; }
          .selection-kids-text,
          .selection-profile-arrow { display:none; }

          .selection-search-input {
            position:absolute;
            right:105px;
            top:18px;
            width:170px;
          }
        }
      `}</style>

      <nav className="selection-navbar">
        <div className="selection-navbar-left">
          <button
            type="button"
            className="selection-icon-button selection-mobile-button"
            onClick={() => setMobileMenuOpen((v) => !v)}
            aria-label="Menu"
          >
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
              <path d="M4 7h16M4 12h16M4 17h16" />
            </svg>
          </button>

          <div className="selection-menu">
            {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
              <button
                key={item}
                type="button"
                className={activeNav === item ? "active" : ""}
                onClick={() => handleNavClick(item)}
              >
                {item}
              </button>
            ))}
          </div>
        </div>

        <div className="selection-navbar-right">
          <button
            type="button"
            className="selection-icon-button"
            onClick={themeToggle}
            aria-label="Toggle theme"
          >
            {darkMode ? (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <circle cx="12" cy="12" r="4" />
                <path d="M12 2v2M12 20v2M4.93 4.93l1.41 1.41M17.66 17.66l1.41 1.41M2 12h2M20 12h2M4.93 19.07l1.41-1.41M17.66 6.34l1.41-1.41" />
              </svg>
            ) : (
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round">
                <path d="M20.5 14.5A8.5 8.5 0 0 1 9.5 3.5 8.5 8.5 0 1 0 20.5 14.5Z" />
              </svg>
            )}
          </button>

          <div className="selection-search-area">
            {searchOpen && (
              <input
                className="selection-search-input"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                placeholder="Search..."
                autoFocus
              />
            )}

            <button
              type="button"
              className={`selection-icon-button ${searchOpen ? "active" : ""}`}
              onClick={() => setSearchOpen((v) => !v)}
              aria-label="Search"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round">
                <circle cx="10.8" cy="10.8" r="6.8" />
                <path d="m16 16 5 5" />
              </svg>
            </button>
          </div>

          <button type="button" className="selection-icon-button" aria-label="Notifications">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8a6 6 0 0 0-12 0c0 7-3 7-3 9h18c0-2-3-2-3-9" />
              <path d="M10 21h4" />
            </svg>
          </button>

          <button
            type="button"
            className="selection-kids-item"
            onClick={() => setAccountName((current) => current === "Kids" ? "Kids" : "Kids")}
          >
            <span className="selection-kids-logo"><span>kids</span></span>
            <span className="selection-kids-text">{accountName}</span>
            <svg className="selection-kids-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </button>

          <div className="selection-profile">
            <button
              type="button"
              className="selection-profile-icon"
              onClick={() => navigate("/profile")}
              aria-label="Profile"
            >
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
                <circle cx="8" cy="8" r="2.2" />
                <circle cx="16" cy="8" r="2.2" />
                <path d="M6 14c1.2 1.5 3.2 2.3 6 2.3s4.8-.8 6-2.3" />
              </svg>
            </button>
            <svg className="selection-profile-arrow" viewBox="0 0 10 10" fill="none" stroke="currentColor" strokeWidth="1.5">
              <path d="M2 3.5 5 6.5 8 3.5" />
            </svg>
          </div>
        </div>
      </nav>

      {mobileMenuOpen && (
        <div className="selection-mobile-panel">
          {["Home", "Teachers", "Subjects", "My Learning"].map((item) => (
            <button
              key={item}
              type="button"
              className={activeNav === item ? "active" : ""}
              onClick={() => handleNavClick(item)}
            >
              {item}
            </button>
          ))}
        </div>
      )}
    </>
  );
}


function TeacherSelection() {

  const navigate = useNavigate();

  const [darkMode, setDarkMode] = useState(() => {
    try {
      return localStorage.getItem("teacher_demo_theme") !== "light";
    } catch (error) {
      return true;
    }
  });

  useEffect(() => {
    try {
      localStorage.setItem("teacher_demo_theme", darkMode ? "dark" : "light");
    } catch (error) {}

    document.body.style.backgroundColor = darkMode ? "#141414" : "#ffffff";
    document.documentElement.style.backgroundColor = darkMode ? "#141414" : "#ffffff";

    return () => {
      document.body.style.backgroundColor = "";
      document.documentElement.style.backgroundColor = "";
    };
  }, [darkMode]);

  const {
    gradeId,
    subjectId,
    moduleId
  } = useParams();

  // FLOW 3:
  // Subject -> Grade -> Module -> Teacher -> MCQ
  // The flow flag is passed from ModuleSelection.
  const [searchParams] = useSearchParams();
  const isSubjectFirstFlow =
    searchParams.get("flow") === "subject-first";

  const [teachers, setTeachers] =
    useState([]);

  const [loading, setLoading] =
    useState(true);

  const [error, setError] =
    useState("");

  const TEACHER_API =
    "https://edunet.kmechengineering.com/root-engine1/api/teacher-data";


  // =====================================================
  // LOAD TEACHERS
  // =====================================================

  useEffect(() => {

    const loadTeachers = async () => {

      setLoading(true);
      setError("");

      try {

        const response =
          await fetch(
            `${TEACHER_API}?subject_id=${encodeURIComponent(
              subjectId
            )}&grade_id=${encodeURIComponent(
              gradeId
            )}`
          );

        if (!response.ok) {

          throw new Error(
            "Failed to load teachers"
          );

        }

        const data =
          await response.json();

        setTeachers(
          data.teacher_data || []
        );

      } catch (error) {

        console.error(
          "Teacher API Error:",
          error
        );

        setTeachers([]);

        setError(
          "Unable to load teachers."
        );

      } finally {

        setLoading(false);

      }

    };


    if (
      gradeId &&
      subjectId
    ) {

      loadTeachers();

    }

  }, [
    gradeId,
    subjectId,
    moduleId
  ]);


  // =====================================================
  // TEACHER CLICK
  // =====================================================

  const handleTeacherClick = (
    teacher
  ) => {

    const teacherId =
      teacher.teacher_id ||
      teacher.id;


    // Save complete flow

    localStorage.setItem(
      "edunet_selected_grade_id",
      gradeId
    );

    localStorage.setItem(
      "edunet_selected_subject_id",
      subjectId
    );

    localStorage.setItem(
      "edunet_selected_module_id",
      moduleId
    );

    localStorage.setItem(
      "edunet_selected_teacher_id",
      teacherId
    );


    /*
     * Open the existing MCQ page.
     *
     * module_id / grade_id / subject_id
     * are also passed as query parameters
     * so the MCQ page can use the selected flow.
     */

    const query = new URLSearchParams({
      grade_id: String(gradeId),
      subject_id: String(subjectId),
      module_id: String(moduleId)
    });

    // Keep Flow 3 information when the user came through:
    // Subject -> Grade -> Module -> Teacher
    if (isSubjectFirstFlow) {
      query.set("flow", "subject-first");
    }

    navigate(
      `/mcq/free/teacher/${encodeURIComponent(
        teacherId
      )}?${query.toString()}`
    );

  };


  // =====================================================
  // PAGE
  // =====================================================

  return (

    <div className={`teacher-selection-page ${darkMode ? "dark-mode" : "light-mode"}`} >

      <style>{`

        * {
          box-sizing: border-box;
        }

        body {
          margin: 0;
          background: #141414;
        }

        .teacher-selection-page {

          min-height: 100vh;

          background:
            linear-gradient(
              180deg,
              #050505 0%,
              #141414 30%,
              #141414 100%
            );

          color: #fff;

          padding-bottom: 70px;

          font-family:
            Arial,
            Helvetica,
            sans-serif;
        }

        .teacher-page-content {

          padding: 42px 40px 0;
        }

        .teacher-back {

          border: none;

          background: transparent;

          color:
            rgba(255,255,255,.72);

          padding: 0;

          margin: 0 0 24px;

          cursor: pointer;

          font-size: 14px;
        }

        .teacher-back:hover {
          color: #fff;
        }

        .teacher-title {

          font-size: 30px;

          font-weight: 700;

          margin: 0 0 7px;
        }

        .teacher-subtitle {

          margin: 0 0 25px;

          color:
            rgba(255,255,255,.58);

          font-size: 14px;
        }

        .section-title {

          font-size: 19px;

          font-weight: 700;

          margin: 0 0 14px;
        }

        .teacher-row {

          display: grid;

          grid-template-columns:
            repeat(
              auto-fit,
              minmax(220px, 1fr)
            );

          gap: 14px;

          width: 100%;
        }

        .teacher-card {

          min-height: 145px;

          border-radius: 7px;

          position: relative;

          overflow: hidden;

          cursor: pointer;

          border:
            1px solid
            rgba(255,255,255,.05);

          background:
            linear-gradient(
              135deg,
              #252525,
              #111
            );

          transition:
            transform .25s ease,
            box-shadow .25s ease,
            border-color .25s ease;
        }

        .teacher-card:hover {

          transform:
            scale(1.035);

          box-shadow:
            0 15px 40px
            rgba(0,0,0,.65);

          border-color:
            rgba(255,255,255,.14);
        }

        .teacher-card::after {

          content: "";

          position: absolute;

          inset: 0;

          background:
            linear-gradient(
              180deg,
              transparent 20%,
              rgba(0,0,0,.9) 100%
            );

          pointer-events: none;
        }

        .teacher-number {

          position: absolute;

          top: 15px;
          left: 17px;

          z-index: 5;

          font-size: 12px;

          color:
            rgba(255,255,255,.58);
        }

        .teacher-name {

          position: absolute;

          left: 17px;
          right: 17px;
          bottom: 17px;

          z-index: 5;

          font-size: 20px;

          font-weight: 700;

          color: #fff;
        }

        .teacher-loading,
        .teacher-empty,
        .teacher-error {

          padding: 45px 0;

          color: #999;

          font-size: 14px;
        }

        .teacher-error {
          color: #ff7777;
        }


        /* =================================================
           LIGHT MODE
        ================================================= */

        .teacher-selection-page.light-mode {
          background: #ffffff;
          color: #111;
        }

        .light-mode .teacher-title { color: #111; }
        .light-mode .teacher-subtitle { color: rgba(0,0,0,.58); }
        .light-mode .section-title { color: #111; }
        .light-mode .teacher-back { color: rgba(0,0,0,.68); }
        .light-mode .teacher-back:hover { color: #111; }

        .light-mode .teacher-card {
          background: linear-gradient(135deg, #f3f3f3, #dedede);
          border-color: rgba(0,0,0,.08);
          box-shadow: 0 8px 24px rgba(0,0,0,.05);
        }

        .light-mode .teacher-card::after {
          background: linear-gradient(180deg, transparent 20%, rgba(0,0,0,.12) 100%);
        }

        .light-mode .teacher-number { color: rgba(0,0,0,.52); }
        .light-mode .teacher-name { color: #111; }

        .light-mode .teacher-loading,
        .light-mode .teacher-empty,
        .light-mode .teacher-error { color: #666; }

        @media(max-width:768px) {

          .teacher-page-content {
            padding: 30px 20px 0;
          }

          .teacher-title {
            font-size: 25px;
          }

          .teacher-row {
            grid-template-columns: 1fr;
          }

        }

      `}</style>


      {/* =====================================================
          NAVBAR
      ===================================================== */}

      <InlineSelectionNavbar darkMode={darkMode} setDarkMode={setDarkMode} activeNav="Home" />


      {/* =====================================================
          CONTENT
      ===================================================== */}

      <main className="teacher-page-content">

        <button
          className="teacher-back"
          onClick={() => navigate(-1)}
        >
          ← Back to Modules
        </button>


        <h1 className="teacher-title">
          Teachers
        </h1>


        <p className="teacher-subtitle">
          Select a teacher to continue
        </p>


        {loading ? (

          <div className="teacher-loading">
            Loading teachers...
          </div>

        ) : error ? (

          <div className="teacher-error">
            {error}
          </div>

        ) : teachers.length === 0 ? (

          <div className="teacher-empty">
            No teachers available.
          </div>

        ) : (

          <section>

            <h2 className="section-title">
              Teachers
            </h2>


            <div className="teacher-row">

              {teachers.map(
                (teacher, index) => (

                  <div
                    key={
                      teacher.teacher_id ||
                      teacher.id ||
                      index
                    }

                    className="teacher-card"

                    onClick={() =>
                      handleTeacherClick(
                        teacher
                      )
                    }
                  >

                    <div className="teacher-number">

                      {String(
                        index + 1
                      ).padStart(2, "0")}

                    </div>


                    <div className="teacher-name">

                      {teacher.name ||
                        `Teacher ${
                          index + 1
                        }`}

                    </div>

                  </div>

                )
              )}

            </div>

          </section>

        )}

      </main>

    </div>

  );

}

export default TeacherSelection;
